import { useParams } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';

import ReportGadgetsContext from 'contexts/ReportGadgetsContext';

const useSelectedGadget = (dashboardGadgetChart?: VisualisationDefinition) => {
  const { gadgetId } = useParams<{ gadgetId?: string }>();
  const { reportGadgetsLookup } = useContext(ReportGadgetsContext);

  const [selected, setSelected] = useState<
    VisualisationDefinition | undefined
  >();

  useEffect(() => {
    if (dashboardGadgetChart) {
      setSelected(dashboardGadgetChart);
    } else if (gadgetId) {
      const reportGadget = reportGadgetsLookup[gadgetId];
      setSelected(reportGadget ? reportGadget.chartDef : undefined);
    } else {
      setSelected(undefined);
    }
  }, [dashboardGadgetChart, reportGadgetsLookup, gadgetId]);

  return {
    selected,
  };
};

export default useSelectedGadget;
